import { render, staticRenderFns } from "./ProductRelated.vue?vue&type=template&id=75612758&"
import script from "./ProductRelated.vue?vue&type=script&lang=js&"
export * from "./ProductRelated.vue?vue&type=script&lang=js&"
import style0 from "./ProductRelated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports